import { defineMessages, type IntlShape } from 'react-intl';

const eligibilityI18n = defineMessages({
	feedbackKeywordForModalTrigger: {
		id: 'automation-discovery.rovo.feedback-analysis.feedback.trigger.keyword',
		defaultMessage: 'feedback',
		description: 'Keyword in page title that triggers automation discovery dialog',
	},
	summaryKeywordForModalTrigger: {
		id: 'automation-discovery.rovo.feedback-analysis.summary.trigger.keyword',
		defaultMessage: 'summary',
		description: 'Keyword in page title that triggers automation discovery dialog',
	},
	analysisKeywordForModalTrigger: {
		id: 'automation-discovery.rovo.feedback-analysis.analysis.trigger.keyword',
		defaultMessage: 'analysis',
		description: 'Keyword in page title that triggers automation discovery dialog',
	},
});

export const isEligibleForFeedbackAnalysisDiscovery = (
	pageTitle: string,
	intl: Pick<IntlShape, 'formatMessage'>,
): boolean => {
	// show the dialog if title contains "analysis" or "feedback summary"
	return (
		pageTitle
			.toLowerCase()
			.includes(intl.formatMessage(eligibilityI18n.analysisKeywordForModalTrigger)) ||
		(pageTitle
			.toLowerCase()
			.includes(intl.formatMessage(eligibilityI18n.feedbackKeywordForModalTrigger)) &&
			pageTitle
				.toLowerCase()
				.includes(intl.formatMessage(eligibilityI18n.summaryKeywordForModalTrigger)))
	);
};
